import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import logo_footer_01 from "../../assets/logo_footer_01.png";
import "../../shared/styles/Footer.css"; // เพิ่มตรงนี้

import { FaFacebookF, FaInstagram } from "react-icons/fa";

function Footer() {
  return (
    <>
      <br />
      <br />

      {/* ส่วนบน: ลิงก์หมวดหมู่ */}
      <Container fluid className="bg-dark">
        <br />

        <Container className="bg-dark">
          <Row className="text-white">
            <Col sm style={{ marginBottom: 30 }}>
              <p>
                <strong>การใช้งานและนโยบาย</strong>
              </p>

              <NavLink to="/terms" className="footer-link">
                ข้อกำหนดการให้บริการ
              </NavLink>
              <br />

              <NavLink to="/privacy" className="footer-link">
                นโยบายความเป็นส่วนตัว
              </NavLink>
              <br />

              <NavLink to="/enchat" className="footer-link">
                เกี่ยวกับ EnChat (AI Chat)
              </NavLink>
            </Col>

            <Col sm style={{ marginBottom: 30 }}>
              <p>
                <strong>เกี่ยวกับ Encraft</strong>
              </p>

              <NavLink to="/about" className="footer-link">
                เกี่ยวกับ Encraft
              </NavLink>
              <br />

              <NavLink to="/contact" className="footer-link">
                ติดต่อเรา
              </NavLink>
            </Col>

            <Col sm />
            <Col sm />
          </Row>
        </Container>
      </Container>

      {/* ส่วนล่าง: โลโก้ / ลิขสิทธิ์ / Social */}
      <Container fluid style={{ backgroundColor: "rgba(255, 221, 0, 1)" }}>
        <Container>
          <br />
          <Row>
            <Col sm>
              <a href="/">
                <img
                  src={logo_footer_01}
                  width="130"
                  className="d-inline-block"
                  alt=""
                />
              </a>
            </Col>

            <Col sm style={{ marginTop: 8, color: "black" }}>
              <p className="footer-copy">© 2025 Encraft. All Rights Reserved.</p>
            </Col>

            <Col />
            <Col
              sm
              className="justify-content-end"
              style={{
                marginTop: 8,
                display: "flex",
                justifyContent: "right",
                gap: "20px",
              }}
            >
              <a
                href="https://www.facebook.com/profile.php?id=61579275334120"
                target="_blank"
                rel="noreferrer"
                className="footer-social-link"
              >
                <FaFacebookF />
              </a>

              <a
                href="https://www.instagram.com/encraft_org"
                target="_blank"
                rel="noreferrer"
                className="footer-social-link"
              >
                <FaInstagram />
              </a>
            </Col>
          </Row>
          <br />
        </Container>
      </Container>
    </>
  );
}

export default Footer;
